import React from 'react';
import { bonuses, OFFER_ANCHOR } from '../data/electrical';
export function BonusSection() {
  return <section className="border-y-4 border-volt bg-white px-4 py-4 sm:py-6" data-id="element-20" data-mp="1ogn79o3opp5f">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="22fd6padz80wy">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-22" data-mp="22ebwf84sbiga">
          🎁 4 PROFESSIONAL BONUSES INCLUDED
        </h2>

        <div className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-23" data-mp="1yc74qexwcvwa">
          {bonuses.map(bonus => <a key={bonus.num} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-volt bg-tech p-2.5 shadow-sm transition-colors duration-150 hover:border-navy" data-id="element-24" data-mp="1am2x7whl8c00">
              <p className="font-head text-[11px] font-extrabold uppercase tracking-wide text-navy" data-id="element-25" data-mp="1epsk8him6lix">
                🎁 BONUS {bonus.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-navy sm:text-lg" data-id="element-26" data-mp="qy3o0q2o9cwp">
                {bonus.title}
              </h3>
              <p className="font-head text-[12px] font-bold text-carbon/70" data-id="element-27" data-mp="29smlkyluqjqs">
                {bonus.subtitle}
              </p>
              {bonus.body.map(paragraph => <p key={paragraph} className="mt-1 text-[13px] font-medium leading-snug text-carbon/80" data-id="element-28" data-mp="2jhwbc7t83qbq">
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-1.5 font-head text-[13px] font-extrabold uppercase text-navy" data-id="element-29" data-mp="1qtquvx97cnhp">
                {bonus.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}